import React from "react";
import { ArrowDown, Play } from "lucide-react";
import { HERO } from "../mock";
import { useEnquiry } from "../context/EnquiryContext";

const Hero = () => {
  const { open: openEnquiry } = useEnquiry();
  return (
    <section id="top" className="relative h-[100svh] min-h-[640px] w-full overflow-hidden bg-[#1f1d1a]">
      {/* Background image with subtle ken-burns */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={HERO.poster}
          alt="Wedding film"
          className="hero-bg w-full h-full object-cover"
        />
      </div>
      <div className="hero-overlay" />

      {/* Foreground content */}
      <div className="relative z-10 h-full flex flex-col">
        <div className="flex-1 flex items-center">
          <div className="max-w-[1400px] mx-auto w-full px-6 md:px-10">
            <div className="max-w-3xl">
              <p className="kicker text-[#e8dfc9] mb-6">A Vow &amp; Video Essex Film</p>
              <h1 className="font-display text-[#f5efe6] display-tight text-[3.6rem] sm:text-[5rem] md:text-[7rem] leading-[0.92] mb-6">
                {HERO.heading_lines[0]}<br/>
                <span className="italic font-light">{HERO.heading_lines[1]}</span>
              </h1>
              <p className="text-[#e8dfc9] text-base md:text-lg max-w-xl font-light leading-relaxed">
                {HERO.sub}
              </p>
              <div className="mt-10 flex flex-wrap items-center gap-4">
                <button onClick={openEnquiry} className="btn-primary" style={{ background:"#f5efe6", color:"#1f1d1a", borderColor:"#f5efe6" }}>
                  Secure Your Date
                </button>
                <a href="#films" className="btn-ghost" style={{ color:"#f5efe6", borderColor:"#f5efe6" }}>
                  <Play size={14} /> Watch Our Films
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pb-8 px-6 md:px-10">
          <div className="max-w-[1400px] mx-auto flex items-end justify-between">
            <a href="#about" className="flex items-center gap-3 text-[#f5efe6] text-[0.72rem] tracking-[0.3em] uppercase">
              <span className="w-10 h-px bg-[#f5efe6]/60" />
              Scroll <ArrowDown size={14} />
            </a>
            <div className="hidden md:block text-right text-[#f5efe6]/80 text-[0.72rem] tracking-[0.3em] uppercase">
              Based in Wickford, Essex<br/>
              <span className="text-[#c9a87c]">Filming love stories since 2015</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
